import React, { useEffect, useState } from "react";
import { useProductGroupsQuery } from "../../hooks/useQueries.ts";
import { useAIClassification } from "../../hooks/useAIClassification.ts";

interface ProductGroupSelectorWithAIProps {
  productName: string;
  value: number | null;
  onChange: (id: number | null) => void;
}

const ProductGroupSelectorWithAI: React.FC<ProductGroupSelectorWithAIProps> = ({
  productName,
  value,
  onChange,
}) => {
  const { data: productGroups } = useProductGroupsQuery();
  const groupNames = productGroups?.map((group) => group.name) ?? [];
  const {
    suggestProductGroup,
    loading: aiLoading,
    error: aiError,
    clearError,
  } = useAIClassification(groupNames);
  const [suggestedGroup, setSuggestedGroup] = useState<string | null>(null);

  useEffect(() => {
    const suggest = async () => {
      if (productName.trim().length >= 3) {
        try {
          clearError();
          const suggestion = await suggestProductGroup(productName.trim());
          setSuggestedGroup(suggestion);
          const matchingGroup = productGroups?.find((group) =>
            group.name === suggestion
          );
          if (matchingGroup) {
            onChange(matchingGroup.id);
          }
        } catch (error) {
          console.error("Failed to get product group suggestion:", error);
        }
      } else {
        setSuggestedGroup(null);
      }
    };
    suggest();
  }, [productName, suggestProductGroup, productGroups, onChange, clearError]);

  return (
    <select
      value={value ?? ""}
      onChange={(e) => onChange(e.target.value ? Number(e.target.value) : null)}
      className="purchase-controls__product-group-select"
    >
      <option value="">
        {aiLoading
          ? "🤖 AI is suggesting a product group..."
          : "Select product group..."}
      </option>
      {productGroups?.map((group) => (
        <option key={group.id} value={group.id}>
          {group.name}
        </option>
      ))}
    </select>
  );
};

export default ProductGroupSelectorWithAI;
